import apiService from '@/member/services/apiService'
import { update } from 'lodash'

const getDefaultState = () => {
  return {
    previousSetting: {
      center: {},
      selectedManagementIds: [],
      colorSettings: {},
    },
  }
}

const state = getDefaultState()

const mutations = {
  SET_PREVIOUS_SETTING(state, payload) {
    if (payload.center) {
      state.previousSetting.center = payload.center
    } else if (payload.selectedManagementIds) {
      state.previousSetting.selectedManagementIds = payload.selectedManagementIds
    } else if (payload.colorSettings) {
      state.previousSetting.colorSettings = payload.colorSettings
    } else {
      state.previousSetting = payload
    }
  },
}

const actions = {
  async getList({ commit }, payload) {
    const apiResult = await apiService.post(route('member.fcs.forest-management-plan.list'), payload)
    if (apiResult && apiResult.success && apiResult.data) {
      return apiResult.data
    }
    return false
  },
  async getRecord({ commit }, payload) {
    const apiResult = await apiService.post(route('member.fcs.forest-management-plan.record'), payload)
    if (apiResult && apiResult.success && apiResult.data) {
      return apiResult.data
    }
    return false
  },
  async create({ commit }, payload) {
    const apiResult = await apiService.post(route('member.fcs.forest-management-plan.create'), payload)
    if (!apiResult.success && apiResult.data) {
      return apiResult.data
    }
    if (apiResult.success && apiResult.data) {
      return apiResult.data
    }
    return false
  },
  async update({ commit }, payload) {
    const apiResult = await apiService.post(route('member.fcs.forest-management-plan.update'), payload)
    if (!apiResult.success && apiResult.data) {
      return apiResult.data
    }
    if (apiResult.success && apiResult.data) {
      return apiResult.data
    }
    return false
  },
  async delete({ commit }, payload) {
    const apiResult = await apiService.post(route('member.fcs.forest-management-plan.delete'), payload)
    if (!apiResult.success && apiResult.data) {
      return apiResult.data
    }
    if (apiResult.success && apiResult.data) {
      return apiResult.data
    }
    return false
  },
  async setPreviousSetting({ commit }, payload) {
    commit('SET_PREVIOUS_SETTING', payload)
  },
}

export default {
  state,
  mutations,
  actions,
}
